import { Option } from 'types'

export const VALIDATE_QUESTION_ANSWER_STATUS_OPTIONS: Option[] = [
  {
    label: 'Aprovado',
    value: 'ACCEPTED',
  },
  {
    label: 'Rejeitado',
    value: 'DECLINED',
  },
]
